import { createFeatureToggle } from '../utilities/createFeatureToggle';
import { ContentfulFeatureToggle } from '../types';
import { FeatureToggle } from './FeatureToggle';

export class FeatureToggleContainer {
  private toggles: FeatureToggle<any, any>[];

  constructor(contentfulToggles?: ContentfulFeatureToggle<any>[]) {
    this.toggles = contentfulToggles?.map(createFeatureToggle) ?? [];
  }

  public getToggles(): FeatureToggle<any, any>[] {
    return this.toggles;
  }

  public overridesDefaultValue(key: string): boolean {
    return this.toggles.some(
      (toggle) =>
        toggle.getKey() === (key as string) && toggle.overridesDefaultValue(),
    );
  }

  public getValue<T>(key: string): T {
    const result: FeatureToggle<any, T> = this.toggles.find(
      (toggle) => toggle.getKey() === (key as string),
    );

    return result?.getValue();
  }
}
